import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PageProgressTabReportWL from "../PageProgress/PageProgressTabReportWL";
import { PortalContext, usePortalSettingSet } from "../../../context/portal-context";
import usePageTitle from "../../../hooks/use-page-title";
import LoadingData from "../../../components/portal/LoadingData";
import ApiSubmission from "../../../modules/api/submission";
import { ROUTES } from "../../../routes";
import ModuleDate from "../../../modules/date";
import ApiMessage, { TMessageItem } from "../../../modules/api/message";
import Utils from "../../../utils/utils";
import { WLField } from "../../../components/dumb/WLFieldsEditor";
import FooterBoxAction from "../../../components/common/FooterBoxAction";

export default function PageWLDetail() {
  const title = "My Workplace Learning Report";
  usePageTitle(title);
  usePortalSettingSet("label_header", title);
  const { setCustomText } = useContext(PortalContext);
  const { submissionId } = useParams();
  const [reportTitle, setReportTitle] = useState("Workplace Learning Report");
  const [loading, setLoading] = useState(true);
  const [submission, setSubmission] = useState<any>({});
  const [fields, setFields] = useState<Array<WLField>>([]);
  const [messages, setMessages] = useState<TMessageItem[]>([]);
  const [isRefreshingMessages, setIsRefreshingMessages] = useState(false);
  const [refreshMessages, setRefreshMessages] = useState(false);
  const [submissionDateStatus, setSubmissionDateStatus] = useState<{ className: string; status: string } | null>(null);

  useEffect(() => {
    ApiSubmission.getSubmission(submissionId).then((res) => {
      if (res.status) {
        let submission = res.data;
        const reportTitle = `Workplace Learning Report (${ModuleDate.getTitleFormat(submission.submissionDate.to)})`;
        setSubmission(submission);
        setReportTitle(reportTitle);
        setCustomText(reportTitle);
        let fields = submission.cohort?.wlFormat?.fields;
        setFields(Array.isArray(fields) ? fields : []);

        if (submission?.submissionDate?.to && submission?.modifiedDate) {
          setSubmissionDateStatus(ModuleDate.getSubmissionStatus(submission.submissionDate.to, submission.modifiedDate));
        }
      }

      setLoading(false);
    });
  }, []);

  useEffect(() => {
    if (loading) return;
    (async () => {
      setIsRefreshingMessages(true);
      const messages = await ApiMessage.getMessagesBySubmission(submissionId, true);
      setMessages(messages.messages);
      await Utils.sleep(1000);
      setIsRefreshingMessages(false);
    })();
  }, [loading, refreshMessages]);

  return (
    <>
      {/* <div className="d-flex gap-2 mb-3"> */}
        {/* <h1 className="fs-title"> */}
          {/* <Link
            to={ROUTES.PORTAL_WORKPLACE_LEARNING}
            className="text-primary p-0 me-2 hide-mobile-down"
            title="Go back"
          >
            <HiArrowLeft />
          </Link> */}
          {/* {reportTitle} */}
        {/* </h1> */}
      {/* </div> */}

      <LoadingData show={loading} />

      {!loading && !submission && (
        <p className="alert alert-warning">Submission not found.</p>
      )}

      {!loading && submission && <>
        <div className="mgr__profile-details">
          <div>
            <div className="mgr__profile-details__info">
              <p className="label">Start Date</p>
              <span className="separator">:</span>
              <p className="value value--normal">
                {ModuleDate.getSubmissionDateFormat(submission?.submissionDate?.from, true)}
              </p>

              <p className="label">Deadline</p>
              <span className="separator">:</span>
              <p className="value value--normal">
                {ModuleDate.getSubmissionDateFormat(submission?.submissionDate?.to, true)}
              </p>
            </div>
          </div>
          <div>
            <div className="mgr__profile-details__info">
              <p className="label">Submission Date</p>
              <span className="separator">:</span>
              <p className="value value--normal">
                {ModuleDate.getSubmissionDateFormat(submission?.modifiedDate, true)}
              </p>

              <p className="label">Submission Status</p>
              <span className="separator">:</span>
              <p className={`value value--normal ${submissionDateStatus?.className || ""}`}>
                {submissionDateStatus?.status || ""}
              </p>
            </div>
          </div>
          <div></div>
        </div>

        <div className="box-default bg-white mb-3 mt-4">
          <PageProgressTabReportWL
            submission={submission}
            fields={fields}
            messages={messages}
            setMessages={setMessages}
            refreshMessages={setRefreshMessages}
            isRefreshingMessages={isRefreshingMessages}
          />
        </div>
      </>}

      <FooterBoxAction backUrl={ROUTES.PORTAL_WORKPLACE_LEARNING}/>

    </>
  );
}
